import React, {
  useRef,
  useImperativeHandle,
  useContext,
  useState,
  useEffect,
} from 'react';
import {
  Box,
  TextField,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  IconButton,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Chip,
  useTheme,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useForm, Controller } from 'react-hook-form';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import { useSelector, useDispatch } from 'dva';
import { Context } from '../../index';
import TitleML from '../TitleML/TitleML';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import webStorage from '@/utils/storageManager';
import {
  download,
  uploadExcel,
  downLoadPrivateFile,
} from '@/utils/downloadUtil.js';
import Loading from '@/components/loading_ml/Loading';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import StoreModal from '@/components/StoreModalML/StoreModal';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
function getStyles(name, arr, theme) {
  return {
    fontWeight:
      arr.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    color: '#000',
  };
}
const getDictCode = (data, type) => {
  const d = data.filter((item) => item.dictCode === type)[0] || {};
  return d.nameZh;
};
export default React.forwardRef(
  // eslint-disable-next-line no-unused-vars
  ({ onSubmitSuccess, queryType = null, handleResetForm, formatMessage }) =>
    // fref,
    {
      const COUPON_USED_TYPE = webStorage.get('DICTOBJ')?.COUPON_USED_TYPE;
      console.log('COUPON_USED_TYPE', COUPON_USED_TYPE);
      const dispatch = useDispatch();
      const theme = useTheme();
      const {
        control,
        handleSubmit,
        errors,
        setValue,
        getValues,
        clearErrors,
      } = useForm();
      const {
        control: storeControl,
        handleSubmit: handleSubmitStore,
        setValue: setValueStore,
        getValues: getValuesStore,
        reset: resetStore,
        watch: watchStore,
      } = useForm();
      const {
        control: storeControlNo,
        handleSubmit: handleSubmitStoreNo,
        setValue: setValueStoreNo,
        getValues: getValuesStoreNo,
        reset: resetStoreNo,
        watch: watchStoreNo,
      } = useForm();
      const [usedTypeOneState, setUsedTypeOneState] = useState();
      const [usedTypeFiveState, setUsedTypeFiveState] = useState();
      const [usedTypeSixState, setUsedTypeSixState] = useState();
      const [usedTypeSevenState, setUsedTypeSevenState] = useState();
      const [storesTypeChooseState, setStoresTypeChooseState] = useState(); //radio选择的值
      const [noUseStory, setNoUseStory] = useState();
      const [useStory, setUseStory] = useState();
      const [storesChooseDataId, setStoresChooseDataId] = useState([]); //可用选中的门店Id
      const [storesChooseItemData, setStoresChooseItemData] = useState([]); //可用存储所有选中数据列
      const [storesChooseItemShowData, setStoresChooseItemShowData] = useState(
        [],
      ); //可用选中的门店点确定后的值列
      const [storesChooseItemShowIdData, setStoresChooseItemShowIdData] =
        useState([]); //可用选中的门店点确定后的值Id

      const [storesChooseDataIdNo, setStoresChooseDataIdNo] = useState([]); //可用选中的门店Id
      const [storesChooseItemDataNo, setStoresChooseItemDataNo] = useState([]); //可用存储所有选中数据列
      const [storesChooseItemShowDataNo, setStoresChooseItemShowDataNo] =
        useState([]); //可用选中的门店点确定后的值列
      const [storesChooseItemShowIdDataNo, setStoresChooseItemShowIdDataNo] =
        useState([]); //可用选中的门店点确定后的值Id

      const [dialogStatus, setDialogStatus] = useState(false); //选中可用门店model的状态
      const [dialogStatusNo, setDialogStatusNo] = useState(false); //选中不可用门店model的状态
      const [isAllCompanyState, setIsAllCompanyState] = useState();
      const [companyId, setCompanyId] = useState([]);
      const [storyType, setStoryType] = useState(1);
      const {
        stepOneData,
        storesList,
        storeName,
        storeCode,
        storesPageSize,
        companyList,
      } = useSelector((state) => state.couponsSetting);
      console.log('++++++', { storeCode, storeName });
      // 批量导入dialog状态
      const [batchImportOpen, setBatchImportOpen] = useState(false);
      //批量上传的input
      const inputUploadExcelRef = useRef();
      //存储点击的是可用商品还是不可用商品的批量导入按钮，1可用，2不可用
      const [importButtonStatus, setImportButtonStatus] = useState();
      //批量导入成功失败的状态监听,ready=>打开导入弹框，start=>点击上传文件按钮，success=>成功，fail=>失败，warning=>有成功有失败
      const [importStatus, setImportStatus] = useState('ready');
      //存储上传成功的数据
      const [uploadSuccessData, setUploadSuccessData] = useState(null);
      //监听批量导入的状态
      const [importFetchStatus, setImportFetchStatus] = useState();
      const { ref } = useContext(Context);
      const submitRefTwo = useRef();
      const clickInput = () => {
        submitRefTwo.current.click();
      };
      useImperativeHandle(ref, () => ({
        // handleSubmit 就是暴露给父组件的方法
        clickInput: clickInput,
      }));

      const [storePage, setStorePage] = useState(1);
      const [storePageNo, setStorePageNo] = useState(1);

      const [storeSearchData, setStoreSearchData] = useState();
      const [storeSearchDataNo, setStoreSearchDataNo] = useState();
      // 门店的分页
      const handleStorePrevious = () => {
        storePage > 1 && setStorePage(storePage - 1);
      };
      const handleStoreDown = () => {
        storesChooseItemShowData.length - storePage * 10 > 0 &&
          setStorePage(storePage + 1);
      };

      //计算总页数
      const initPageSize = (num) => {
        return Math.ceil(num / 10);
      };

      //计算当前分页的列表
      const initDataTables = (list, page) => {
        const newList = list ?? [];
        const startPage = page > 1 ? (page - 1) * 10 : 0;
        const endPage = 10;
        const data = [...newList].splice(startPage, endPage);
        return data;
      };

      // 不可用门店的分页
      const handleStorePreviousNo = () => {
        storePageNo > 1 && setStorePageNo(storePageNo - 1);
      };
      const handleStoreDownNo = () => {
        storesChooseItemShowDataNo.length - storePageNo * 10 > 0 &&
          setStorePageNo(storePageNo + 1);
      };

      //计算总页数
      // const initPageSize = (num) => {
      //   return Math.ceil(num / 10);
      // };

      //计算当前分页的列表
      // const initDataTablesNo = (list, page) => {
      //   const newList = list ?? [];
      //   const startPage = page > 1 ? (page - 1) * 10 : 0;
      //   const endPage = 10;
      //   const data = [...newList].splice(startPage, endPage);
      //   return data;
      // };

      useEffect(() => {
        setValue('isAllCompany', String(stepOneData.isAllCompany));
      }, [stepOneData.isAllCompany, setValue]);

      useEffect(() => {
        setValue('web', stepOneData.usedType.includes(1));
        setValue('etoshop', stepOneData.usedType.includes(5));
        setValue('offline', stepOneData.usedType.includes(6));
        setValue('privateProgram', stepOneData.usedType.includes(7));
        setValue('isAllStore', String(stepOneData.isAllStore));

        //可用
        const defaultStores = stepOneData.stores;
        let defaultIds = []; //ids
        if (defaultStores.length > 0) {
          defaultIds = defaultStores.map((item) => item.id);
        }
        setStoresChooseDataId(defaultIds);
        setStoresChooseItemShowIdData(defaultIds);
        setStoresChooseItemData(defaultStores);
        setStoresChooseItemShowData(defaultStores);
        setValue('stores', JSON.stringify(defaultStores));
        //不可用
        const defaultStoresNo = stepOneData.invertStores;
        let defaultIdsNo = []; //ids
        if (defaultStoresNo.length > 0) {
          defaultIdsNo = defaultStoresNo.map((item) => item.id);
        }
        setStoresChooseDataIdNo(defaultIdsNo);
        setStoresChooseItemShowIdDataNo(defaultIdsNo);
        setStoresChooseItemDataNo(defaultStoresNo);
        setStoresChooseItemShowDataNo(defaultStoresNo);
        setValue('invertStores', JSON.stringify(defaultStoresNo));
      }, [
        stepOneData.usedType,
        stepOneData.isAllStore,
        setValue,
        stepOneData.stores,
        stepOneData.invertStores,
      ]);

      useEffect(() => {
        setValue('companies', stepOneData.companies);
        setValue('useStory', stepOneData.useStory);
        setValue('noUseStory', stepOneData.noUseStory);
        setCompanyId(stepOneData.companies);
      }, [
        setValue,
        stepOneData.companies,
        stepOneData.noUseStory,
        stepOneData.useStory,
      ]);
      const deUsedTypeOneState = stepOneData.usedType.includes(1);
      const deUsedTypeFiveState = stepOneData.usedType.includes(5);
      const deUsedTypeSixState = stepOneData.usedType.includes(6);
      const deUsedTypeSevenState = stepOneData.usedType.includes(7);
      let deStoresTypeChooseState = String(stepOneData.isAllStore);
      const deIsAllCompanyState = String(stepOneData.isAllCompany);
      const deCompanyId = stepOneData.companies;
      const deNoUseStory = stepOneData.noUseStory;
      const deUseStory = stepOneData.useStory;
      const columns = [
        {
          type: 'checkbox',
          width: '100',
          onChange: (a) => {
            if (storyType === 1) {
              const pageDataIds = storesList.map((item) => item.id); //当前分页的id数组
              const prevStoresChooseItemData = storesChooseItemData.filter(
                (item) => {
                  //过滤掉当前页的选中列
                  return pageDataIds.indexOf(item.id) === -1;
                },
              );

              // const prevStoresChooseIds = storesChooseDataId.filter(item => {//过滤掉当前页的选中ids
              //   return pageDataIds.indexOf(item) === -1
              // });

              let chooseDatas = storesList.filter((fItem) => {
                //当前选中的数据过滤出当前页的数据
                return a.includes(fItem.id);
              });

              const newListData = [...prevStoresChooseItemData, ...chooseDatas];
              //将选中的数据a替换老数据
              const newIdsData = newListData.map((item) => item.id);
              setStoresChooseDataId(newIdsData);
              setStoresChooseItemData(newListData);
            } else {
              const pageDataIdsNo = storesList.map((item) => item.id); //当前分页的id数组
              const prevStoresChooseItemDataNo = storesChooseItemDataNo.filter(
                (item) => {
                  //过滤掉当前页的选中列
                  return pageDataIdsNo.indexOf(item.id) === -1;
                },
              );

              // const prevStoresChooseIds = storesChooseDataId.filter(item => {//过滤掉当前页的选中ids
              //   return pageDataIds.indexOf(item) === -1
              // });

              let chooseDatasNo = storesList.filter((fItem) => {
                //当前选中的数据过滤出当前页的数据
                return a.includes(fItem.id);
              });

              const newListDataNo = [
                ...prevStoresChooseItemDataNo,
                ...chooseDatasNo,
              ];
              const newIdsDataNo = newListDataNo.map((item) => item.id);
              //将选中的数据a替换老数据
              setStoresChooseDataIdNo(newIdsDataNo);
              setStoresChooseItemDataNo(newListDataNo);
            }
          },
        },
        {
          title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt63' }),
          id: 'storeNo',
          align: 'center',
          width: 150,
        },
        {
          title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt64' }),
          id: 'name',
          align: 'center',
          width: 200,
        },
        {
          title: '门店状态',
          id: 'statusCn',
          align: 'center',
          width: 100,
        },
        {
          title: '门店类型',
          id: 'storeType',
          align: 'center',
          width: 100,
        },
      ];
      const showColumns = [
        {
          title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt63' }),
          id: 'storeNo',
          align: 'center',
          width: 150,
        },
        {
          title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt64' }),
          id: 'name',
          align: 'center',
          width: 460,
        },
        {
          title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt65' }),
          align: 'center',
          id: 'details',
          width: 100,
          render: (items) => {
            return (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  lineHeight: '64px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    lineHeight: '64px',
                    cursor: 'pointer',
                  }}
                >
                  <ButtonTip title="Delete">
                    <DeleteForeverOutlinedIcon
                      style={{
                        fontSize: '20px',
                        color: queryType === 'detail' ? 'darkgray' : '#525CA3',
                      }}
                      onClick={() => {
                        setStoryType(1);
                        queryType !== 'detail' &&
                          handleDeleteStores(items.id, 1);
                      }}
                    ></DeleteForeverOutlinedIcon>
                  </ButtonTip>
                </div>
              </div>
            );
          },
        },
      ];
      const showColumnsNo = [
        {
          title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt63' }),
          id: 'storeNo',
          align: 'center',
          width: 150,
        },
        {
          title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt64' }),
          id: 'name',
          align: 'center',
          width: 460,
        },
        {
          title: formatMessage({ id: 'coupon.mgt.pricevalue.n01.txt65' }),
          align: 'center',
          id: 'details',
          width: 100,
          render: (items) => {
            return (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  lineHeight: '64px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    lineHeight: '64px',
                    cursor: 'pointer',
                  }}
                >
                  <ButtonTip title="Delete">
                    <DeleteForeverOutlinedIcon
                      style={{
                        fontSize: '20px',
                        color: queryType === 'detail' ? 'darkgray' : '#525CA3',
                      }}
                      onClick={() => {
                        setStoryType(2);
                        queryType !== 'detail' &&
                          handleDeleteStores(items.id, 2);
                      }}
                    ></DeleteForeverOutlinedIcon>
                  </ButtonTip>
                </div>
              </div>
            );
          },
        },
      ];
      //点击删除已经选中的门店
      const handleDeleteStores = (id, type) => {
        if (type === 1) {
          const prevStoresChooseDataId = storesChooseDataId.filter((item) => {
            return item !== id;
          });
          const prevStoresChooseItemData = storesChooseItemData.filter(
            (item) => {
              return item.id !== id;
            },
          );
          const prevStoresChooseItemShowData = storesChooseItemShowData.filter(
            (item) => {
              return item.id !== id;
            },
          );
          const prevStoresChooseItemShowIdData =
            storesChooseItemShowIdData.filter((item) => {
              return item !== id;
            });
          setStoresChooseDataId(prevStoresChooseDataId);
          setStoresChooseItemData(prevStoresChooseItemData);
          setStoresChooseItemShowData(prevStoresChooseItemShowData);
          setStoresChooseItemShowIdData(prevStoresChooseItemShowIdData);
          setValue(
            'stores',
            (storesTypeChooseState ?? deStoresTypeChooseState) === '0'
              ? JSON.stringify(prevStoresChooseItemShowData)
              : '',
          );
        } else {
          const prevStoresChooseDataIdNo = storesChooseDataIdNo.filter(
            (item) => {
              return item !== id;
            },
          );
          const prevStoresChooseItemDataNo = storesChooseItemDataNo.filter(
            (item) => {
              return item.id !== id;
            },
          );
          const prevStoresChooseItemShowDataNo =
            storesChooseItemShowDataNo.filter((item) => {
              return item.id !== id;
            });
          const prevStoresChooseItemShowIdDataNo =
            storesChooseItemShowIdDataNo.filter((item) => {
              return item !== id;
            });
          setStoresChooseDataIdNo(prevStoresChooseDataIdNo);
          setStoresChooseItemDataNo(prevStoresChooseItemDataNo);
          setStoresChooseItemShowDataNo(prevStoresChooseItemShowDataNo);
          setStoresChooseItemShowIdDataNo(prevStoresChooseItemShowIdDataNo);
          setValue(
            'invertStores',
            (storesTypeChooseState ?? deStoresTypeChooseState) === '0'
              ? JSON.stringify(prevStoresChooseItemShowDataNo)
              : '',
          );
        }
      };
      const onCloseDialog = (data) => {
        if (data) {
          setStoresChooseItemShowData(storesChooseItemData);
          setStoresChooseItemShowIdData(storesChooseDataId);
        } else {
          setStoresChooseItemData(storesChooseItemShowData);
          setStoresChooseDataId(storesChooseItemShowIdData);
        }
        setValue(
          'stores',
          (storesTypeChooseState ?? deStoresTypeChooseState) === '0'
            ? JSON.stringify(storesChooseItemData)
            : '',
        );
        setDialogStatus(false);
      };
      const onCloseDialogNo = (data) => {
        if (data) {
          setStoresChooseItemShowDataNo(storesChooseItemDataNo);
          setStoresChooseItemShowIdDataNo(storesChooseDataIdNo);
        } else {
          setStoresChooseItemDataNo(storesChooseItemShowDataNo);
          setStoresChooseDataIdNo(storesChooseItemShowIdDataNo);
        }
        setValue(
          'invertStores',
          (storesTypeChooseState ?? deStoresTypeChooseState) === '0'
            ? JSON.stringify(storesChooseItemDataNo)
            : '',
        );
        setDialogStatusNo(false);
      };

      //打开门店选中model
      const storesAddClick = (type) => {
        console.log('......', storyType, type);
        if (storyType !== type) {
          setStoryType(type);
          let initData = type === 1 ? storeSearchData : storeSearchDataNo;
          dispatch({
            type: 'couponsSetting/searchStores',
            payload: {
              value: {
                ...initData,
                pageNum: 1,
                pageSize: storesPageSize,
              },
            },
          });
        }
        type === 1 ? setDialogStatus(true) : setDialogStatusNo(true);
      };

      const onHandleClickSearchStores = (data) => {
        dispatch({
          type: 'couponsSetting/searchStores',
          payload: {
            value: { ...data, pageNum: 1, pageSize: storesPageSize },
          },
        });
      };

      const onSubmitSuccessStore = (data) => {
        onHandleClickSearchStores(data);
        setStoreSearchData(data);
      };
      const onHandleClickSearchStoresReset = () => {
        setStoreSearchData();
      };
      const onSubmitSuccessStoreNo = (data) => {
        onHandleClickSearchStores(data);
        setStoreSearchDataNo(data);
      };
      const onHandleClickSearchStoresResetNo = () => {
        setStoreSearchDataNo();
      };

      /*
       * importButtonStatus 1可用商品， 2不可用商品
       * here
       */
      const storesImportClick = (buttonStatus) => {
        setBatchImportOpen(true);
        setImportButtonStatus(buttonStatus);
      };
      //打开关闭批量导入dialog
      const onCloseBatchImportDialog = () => {
        setBatchImportOpen(false);
        setImportStatus('ready');
        setUploadSuccessData();
      };
      //批量导入的内容部分
      const batchImportContent = () => {
        return (
          <Loading loading={importFetchStatus}>
            <Box gap="16px 0" display="flex" flexDirection="column">
              <Box display="flex" alignItems="center">
                <Box
                  sx={{
                    width: '32px',
                    height: '32px',
                    fontSize: '16px',
                    color: '#ffffff',
                    background: theme.palette.primary.main,
                    borderRadius: '50%',
                    textAlign: 'center',
                    lineHeight: '32px',
                    marginRight: '10px',
                  }}
                >
                  1
                </Box>
                <Box sx={{ fontSize: '16px', color: '#212121' }}>
                  根据标准模板格式填写信息，前往
                  <span
                    style={{
                      color: theme.palette.primary.main,
                      cursor: 'pointer',
                    }}
                    onClick={handleDownloadExcelTemplate}
                  >
                    下载模板{'>'}
                    {'>'}
                  </span>
                </Box>
              </Box>
              <Box display="flex" alignItems="center">
                <Box
                  sx={{
                    width: '32px',
                    height: '32px',
                    fontSize: '16px',
                    color: '#ffffff',
                    background: theme.palette.primary.main,
                    borderRadius: '50%',
                    textAlign: 'center',
                    lineHeight: '32px',
                    marginRight: '10px',
                  }}
                >
                  2
                </Box>
                <Box sx={{ fontSize: '16px', color: '#212121' }}>
                  点击上传文件按钮，上传后系统将对文件内容进行检查
                </Box>
              </Box>
              {importStatus !== 'ready' && (
                <Box
                  sx={{
                    border:
                      importStatus === 'success'
                        ? '2px solid #4CAF50'
                        : importStatus === 'warning'
                        ? '2px solid #FF9800'
                        : '2px solid #FF3B30',
                    borderRadius: '5px',
                    padding: '12px 24px',
                    marginBottom: importStatus === 'fail' ? '16px' : 0,
                  }}
                >
                  <Box
                    sx={{
                      height: '22px',
                      lineHeight: '22px',
                      fontSize: '16px',
                      color:
                        importStatus === 'success'
                          ? '#4CAF50'
                          : importStatus === 'warning'
                          ? '#FF9800'
                          : '#FF3B30',
                    }}
                  >
                    {importStatus === 'success' ? (
                      '文件上传成功'
                    ) : importStatus === 'warning' ? (
                      <>
                        文件内容校验异常，点我
                        <span
                          style={{
                            color: theme.palette.primary.main,
                            cursor: 'pointer',
                          }}
                          onClick={handleDownloadExcelFailData}
                        >
                          下载文件{'>'}
                          {'>'}
                        </span>
                      </>
                    ) : (
                      '文件上传失败'
                    )}
                  </Box>
                  <Box
                    sx={{
                      lineHeight: '22px',
                      fontSize: '16px',
                      color: '#212121',
                      marginTop: '8px',
                    }}
                  >
                    {importStatus === 'success' ? (
                      `共计上传${uploadSuccessData?.totalNum}条数据，成功${uploadSuccessData?.successNum}条，失败${uploadSuccessData?.failNum}条。`
                    ) : importStatus === 'warning' ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `共计上传${uploadSuccessData?.totalNum}条数据，成功${uploadSuccessData?.successNum}条，失败${uploadSuccessData?.failNum}条。<br />你可以下载未上传成功的数据`,
                        }}
                      />
                    ) : (
                      '请下载模板，按照指定方式上传！'
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          </Loading>
        );
      };
      //批量导入底部按钮自定义
      const initButton = () => {
        const buttonNode = (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: '0 32px',
              width: '100%',
              marginBottom: '16px',
            }}
          >
            {importStatus === 'ready' && (
              <Button
                sx={{ width: '100px!important' }}
                variant="contained"
                onClick={handleUploadExcel}
              >
                上传文件
              </Button>
            )}
            {(importStatus === 'success' || importStatus === 'warning') && (
              <Button
                sx={{ width: '100px!important' }}
                variant="contained"
                onClick={!importFetchStatus && onContinueBatchImport}
              >
                继续
              </Button>
            )}
            {(importStatus === 'success' || importStatus === 'warning') && (
              <Button
                sx={{
                  width: '100px!important',
                  color: theme.palette.primary.main,
                }}
                variant="outlined"
                onClick={onCloseBatchImportDialog}
              >
                取消
              </Button>
            )}
          </Box>
        );
        return { buttonNode, isShow: importStatus !== 'fail' };
      };

      //下载模板
      const handleDownloadExcelTemplate = () => {
        download('/common/importStoresTemplate');
      };

      //上传excel
      const handleUploadExcel = () => {
        inputUploadExcelRef.current.click();
      };
      //批量上传
      const handleFileChange = (e) => {
        setImportFetchStatus(1);
        let storesNo = [];
        if (importButtonStatus === 1) {
          storesNo = storesChooseItemShowData?.map((item) => item.storeNo);
        } else {
          storesNo = storesChooseItemShowDataNo?.map((item) => item.storeNo);
        }
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('stores', storesNo);
        // 上传excel
        uploadExcel(file, formData, '/common/importStores', (res) => {
          if (res?.code === 0) {
            if (res.data.failNum === 0) {
              setImportStatus('success');
            } else {
              setImportStatus('warning');
            }
            setUploadSuccessData(res.data);
          } else {
            setImportStatus('fail');
          }
          inputUploadExcelRef.current.value = '';
          setImportFetchStatus();
        });
      };
      //点击批量导入的继续按钮
      const onContinueBatchImport = () => {
        const { storeList } = uploadSuccessData;
        if (importButtonStatus === 1) {
          const filterStoresList = storeList.filter(
            (item) => !storesChooseDataId.includes(item.id),
          );
          const defaultIds = filterStoresList.map((item) => item.id);
          //门店开始
          setStoresChooseDataId([...storesChooseDataId, ...defaultIds]);
          setStoresChooseItemData([
            ...storesChooseItemData,
            ...filterStoresList,
          ]);
          setStoresChooseItemShowData([
            ...storesChooseItemShowData,
            ...filterStoresList,
          ]);
          setStoresChooseItemShowIdData([
            ...storesChooseItemShowIdData,
            ...defaultIds,
          ]);
          setValue(
            'stores',
            JSON.stringify([...storesChooseItemData, ...filterStoresList]),
          );
          //门店结束
        } else {
          const filterStoresList = storeList.filter(
            (item) => !storesChooseDataIdNo.includes(item.id),
          );
          const defaultIds = filterStoresList.map((item) => item.id);
          setStoresChooseDataIdNo([...storesChooseDataIdNo, ...defaultIds]);
          setStoresChooseItemDataNo([
            ...storesChooseItemDataNo,
            ...filterStoresList,
          ]);
          setStoresChooseItemShowDataNo([
            ...storesChooseItemShowDataNo,
            ...filterStoresList,
          ]);
          setStoresChooseItemShowIdDataNo([
            ...storesChooseItemShowIdDataNo,
            ...defaultIds,
          ]);
          setValue(
            'invertStores',
            JSON.stringify([...storesChooseItemDataNo, ...filterStoresList]),
          );
        }
        setBatchImportOpen(false);
        setImportStatus('ready');
        setUploadSuccessData();
      };
      //点击下载批量导入失败的数据
      const handleDownloadExcelFailData = () => {
        const { failFilePath } = uploadSuccessData;
        downLoadPrivateFile(failFilePath);
      };

      const changePageStore = (data) => {
        dispatch({
          type: 'couponsSetting/setStoresPage',
          payload: {
            value: {
              pageNum: data.pageNum,
              pageSize: data.pageSize,
            },
          },
        });
      };
      return (
        <Box className="step-form-wrap">
          <input
            className="input"
            type="file"
            ref={inputUploadExcelRef}
            hidden
            onChange={(event) => handleFileChange(event)}
            accept={
              ('application/vnd.ms-excel.xlsx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            }
          />
          <form onSubmit={handleSubmit(onSubmitSuccess)}>
            <Box display="flex">
              {/*内容*/}
              <Box flex="1" pl={7}>
                <Box>
                  <TitleML
                    title={formatMessage({
                      id: 'coupon.mgt.volume.n02.lbl01',
                    })}
                    fontSize="19px"
                  />
                  <Box>
                    {/*适用渠道*/}
                    <Box width="100%" mt={5}>
                      <Box
                        fontSize="14px"
                        fontWeight="400"
                        color="#000"
                        mb={1.6}
                      >
                        <span style={{ color: 'red' }}>*</span>{' '}
                        {formatMessage({
                          id: 'coupon.mgt.volume.n02.chb02',
                        })}
                      </Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        width="460px"
                        justifyContent="space-between"
                      >
                        <Box className="checkbox-radio-disabled-color">
                          <Controller
                            render={(pr) => (
                              <FormControlLabel
                                variant="standard"
                                checked={usedTypeOneState ?? deUsedTypeOneState}
                                control={<Checkbox color="primary" />}
                                label={
                                  <Box color="#000">
                                    {COUPON_USED_TYPE &&
                                      getDictCode(COUPON_USED_TYPE, 'WEBSITE')}
                                  </Box>
                                }
                                onChange={(e) => {
                                  setUsedTypeOneState(e.target.checked);
                                  if (e.target.checked) {
                                    clearErrors([
                                      'offline',
                                      'web',
                                      'etoshop',
                                      'privateProgram',
                                    ]);
                                  }
                                  return pr.onChange(e.target.checked);
                                }}
                                disabled={queryType === 'detail'}
                              />
                            )}
                            control={control}
                            name="web"
                            rules={{
                              validate: () => {
                                if (
                                  !getValues('offline') &&
                                  !getValues('web') &&
                                  !getValues('etoshop') &&
                                  !getValues('privateProgram')
                                ) {
                                  return false;
                                }
                                return true;
                              },
                            }}
                          />
                        </Box>

                        <Box className="checkbox-radio-disabled-color">
                          <Controller
                            render={(pr) => (
                              <FormControlLabel
                                variant="standard"
                                checked={
                                  usedTypeFiveState ?? deUsedTypeFiveState
                                }
                                control={<Checkbox color="primary" />}
                                label={
                                  <Box color="#000">
                                    {COUPON_USED_TYPE &&
                                      getDictCode(
                                        COUPON_USED_TYPE,
                                        'MINIPROGRAM',
                                      )}
                                  </Box>
                                }
                                onChange={(e) => {
                                  setUsedTypeFiveState(e.target.checked);
                                  if (e.target.checked) {
                                    clearErrors([
                                      'offline',
                                      'web',
                                      'etoshop',
                                      'privateProgram',
                                    ]);
                                  }
                                  return pr.onChange(e.target.checked);
                                }}
                                disabled={queryType === 'detail'}
                              />
                            )}
                            control={control}
                            name="etoshop"
                            rules={{
                              validate: () => {
                                if (
                                  !getValues('offline') &&
                                  !getValues('web') &&
                                  !getValues('etoshop') &&
                                  !getValues('privateProgram')
                                ) {
                                  return false;
                                }
                                return true;
                              },
                            }}
                          />
                        </Box>
                        <Box className="checkbox-radio-disabled-color">
                          <Controller
                            render={(pr) => (
                              <FormControlLabel
                                variant="standard"
                                checked={usedTypeSixState ?? deUsedTypeSixState}
                                control={<Checkbox color="primary" />}
                                label={
                                  <Box color="#000">
                                    {COUPON_USED_TYPE &&
                                      getDictCode(COUPON_USED_TYPE, 'OFFLINE')}
                                  </Box>
                                }
                                onChange={(e) => {
                                  setUsedTypeSixState(e.target.checked);
                                  if (e.target.checked) {
                                    clearErrors([
                                      'offline',
                                      'web',
                                      'etoshop',
                                      'privateProgram',
                                    ]);
                                  }
                                  return pr.onChange(e.target.checked);
                                }}
                                disabled={queryType === 'detail'}
                              />
                            )}
                            control={control}
                            name="offline"
                            rules={{
                              validate: () => {
                                if (
                                  !getValues('offline') &&
                                  !getValues('web') &&
                                  !getValues('etoshop') &&
                                  !getValues('privateProgram')
                                ) {
                                  return false;
                                }
                                return true;
                              },
                            }}
                          />
                        </Box>
                        <Box className="checkbox-radio-disabled-color">
                          <Controller
                            render={(pr) => (
                              <FormControlLabel
                                variant="standard"
                                checked={
                                  usedTypeSevenState ?? deUsedTypeSevenState
                                }
                                control={<Checkbox color="primary" />}
                                label={
                                  <Box color="#000">
                                    {COUPON_USED_TYPE &&
                                      getDictCode(
                                        COUPON_USED_TYPE,
                                        'PRIVATEPROGRAM',
                                      )}
                                  </Box>
                                }
                                onChange={(e) => {
                                  setUsedTypeSevenState(e.target.checked);
                                  if (e.target.checked) {
                                    clearErrors([
                                      'offline',
                                      'web',
                                      'etoshop',
                                      'privateProgram',
                                    ]);
                                  }
                                  return pr.onChange(e.target.checked);
                                }}
                                disabled={queryType === 'detail'}
                              />
                            )}
                            control={control}
                            name="privateProgram"
                            rules={{
                              validate: () => {
                                if (
                                  !getValues('offline') &&
                                  !getValues('web') &&
                                  !getValues('etoshop') &&
                                  !getValues('privateProgram')
                                ) {
                                  return false;
                                }
                                return true;
                              },
                            }}
                          />
                        </Box>
                      </Box>
                      <Box className="init-error-style" ml={0}>
                        {errors.offline &&
                          errors.web &&
                          errors.etoshop &&
                          errors.privateProgram &&
                          formatMessage({
                            id: 'coupon.mgt.pricevalue.n01.txt69',
                          })}
                      </Box>
                    </Box>
                    {/*适用公司*/}
                    <Box width="100%" mt={7.5}>
                      <Box
                        fontSize="14px"
                        fontWeight="400"
                        color="#000"
                        mb={1.6}
                      >
                        <span style={{ color: 'red' }}>*</span>{' '}
                        {formatMessage({
                          id: 'coupon.mgt.volume.n02.rdo06',
                        })}
                      </Box>
                      <Box display="flex">
                        <Controller
                          render={(pr) => (
                            <RadioGroup
                              className="checkbox-radio-disabled-color"
                              aria-label="couponUsingThreshold"
                              onChange={(e) => {
                                e.target.value === 'true' &&
                                  setValue('companies', []);
                                e.target.value === 'true' &&
                                  handleResetForm('companies', []);
                                setIsAllCompanyState(e.target.value);
                                return pr.onChange(e.target.value);
                              }}
                              value={isAllCompanyState ?? deIsAllCompanyState}
                            >
                              <Box display="flex" gridGap="0 53px">
                                <Box display="flex" mr={11}>
                                  <FormControlLabel
                                    variant="standard"
                                    value="true"
                                    control={<Radio />}
                                    label={
                                      <Box color="#000" lineHeight="1">
                                        {formatMessage({
                                          id: 'coupon.mgt.volume.n02.lbl07',
                                        })}
                                      </Box>
                                    }
                                    disabled={queryType === 'detail'}
                                  />
                                </Box>
                                <Box>
                                  <FormControlLabel
                                    variant="standard"
                                    value="false"
                                    control={<Radio />}
                                    label={
                                      <Box color="#000" lineHeight="1">
                                        {formatMessage({
                                          id: 'coupon.mgt.volume.n02.rdo08',
                                        })}
                                      </Box>
                                    }
                                    disabled={queryType === 'detail'}
                                  />
                                </Box>
                              </Box>
                            </RadioGroup>
                          )}
                          control={control}
                          name="isAllCompany"
                          rules={{
                            validate: () => {
                              if (
                                getValues('isAllCompany') === 'false' &&
                                getValues('companies').length === 0
                              ) {
                                return false;
                              }
                              return true;
                            },
                          }}
                        />
                        <Box sx={{ marginTop: '-12px' }}>
                          <Controller
                            render={(pr) => (
                              <FormControl
                                sx={{ m: 1, width: 540 }}
                                variant="standard"
                                className="multiple-wrap-style"
                                disabled={
                                  (isAllCompanyState ?? deIsAllCompanyState) ===
                                    'true' || queryType === 'detail'
                                }
                              >
                                <InputLabel id="demo-multiple-chip-label">
                                  {formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt70',
                                  })}
                                </InputLabel>
                                <Select
                                  labelId="demo-multiple-chip-label"
                                  id="demo-multiple-chip"
                                  multiple
                                  value={companyId || deCompanyId}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setCompanyId(
                                      typeof value === 'string'
                                        ? value.split(',')
                                        : value,
                                    );
                                    return pr.onChange(e.target.value);
                                  }}
                                  // input={
                                  //   <OutlinedInput
                                  //     id="select-multiple-chip"
                                  //     label="Chip"
                                  //   />
                                  // }
                                  renderValue={(selected) => {
                                    return Array.isArray(selected) &&
                                      selected.length > 0 ? (
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          flexWrap: 'wrap',
                                        }}
                                      >
                                        {selected.map((value) => (
                                          <Chip
                                            key={value}
                                            label={(() => {
                                              const data = companyList.find(
                                                (item) => item.id === value,
                                              );
                                              return <>{data.name}</>;
                                            })()}
                                            sx={{ m: '2px' }}
                                          />
                                        ))}
                                      </Box>
                                    ) : (
                                      ''
                                    );
                                  }}
                                  MenuProps={MenuProps}
                                >
                                  {Array.isArray(companyList) &&
                                    companyList.length > 0 &&
                                    companyList.map((data) => (
                                      <MenuItem
                                        key={data.id}
                                        value={data.id}
                                        style={getStyles(
                                          data.id,
                                          companyId,
                                          theme,
                                        )}
                                      >
                                        {data.name}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            )}
                            control={control}
                            name="companies"
                            rules={
                              {
                                // validate: () => {
                                //   if (
                                //     getValues('isAllStore') === '1' &&
                                //     storesChooseItemShowData.length === 0
                                //   )
                                //     return false;
                                //   else return true;
                                // },
                              }
                            }
                          />
                          {(isAllCompanyState ?? deIsAllCompanyState) ===
                            'false' &&
                          companyId.length === 0 &&
                          deCompanyId.length === 0 ? (
                            <Box className="input-error-style">
                              {errors.isAllCompany
                                ? formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt71',
                                  })
                                : ''}
                            </Box>
                          ) : (
                            ''
                          )}
                        </Box>
                      </Box>
                    </Box>
                    {/*适用门店*/}
                    <Box width="100%" mt={7.5}>
                      <Box
                        fontSize="14px"
                        fontWeight="400"
                        color="#000"
                        mb={1.6}
                      >
                        <span style={{ color: 'red' }}>*</span>{' '}
                        {formatMessage({
                          id: 'coupon.mgt.volume.n02.rdo09',
                        })}
                      </Box>
                      <Box display="flex">
                        <Controller
                          render={(pr) => (
                            <RadioGroup
                              className="checkbox-radio-disabled-color"
                              aria-label="couponUsingThreshold"
                              onChange={(e) => {
                                setStoresTypeChooseState(e.target.value);
                                deStoresTypeChooseState = undefined;
                                return pr.onChange(e.target.value);
                              }}
                              value={
                                storesTypeChooseState ?? deStoresTypeChooseState
                              }
                            >
                              <Box display="flex" gridGap="0 53px">
                                <Box display="flex" mr={11}>
                                  <FormControlLabel
                                    variant="standard"
                                    value="1"
                                    control={<Radio />}
                                    label={
                                      <Box color="#000" lineHeight="1">
                                        {formatMessage({
                                          id: 'coupon.mgt.volume.n02.lbl10',
                                        })}
                                      </Box>
                                    }
                                    disabled={queryType === 'detail'}
                                  />
                                </Box>
                                <Box mr={3}>
                                  <FormControlLabel
                                    variant="standard"
                                    value="0"
                                    control={<Radio />}
                                    label={
                                      <Box color="#000" lineHeight="1">
                                        {formatMessage({
                                          id: 'coupon.mgt.volume.n02.lbl11',
                                        })}
                                      </Box>
                                    }
                                    disabled={queryType === 'detail'}
                                  />
                                </Box>
                              </Box>
                            </RadioGroup>
                          )}
                          control={control}
                          name="isAllStore"
                          rules={{
                            validate: () => {
                              if (
                                (getValues('isAllStore') === '0' &&
                                  storesChooseItemShowData.length === 0 &&
                                  storesChooseItemShowDataNo.length === 0) ||
                                (getValues('isAllStore') === '0' &&
                                  !(useStory ?? deUseStory) &&
                                  !(noUseStory ?? deNoUseStory))
                              ) {
                                return false;
                              }
                              return true;
                            },
                          }}
                        />
                      </Box>
                      <Box className="init-error-style">
                        {errors.isAllStore &&
                          formatMessage({
                            id: 'coupon.mgt.pricevalue.n01.txt72',
                          })}
                      </Box>
                      {/*适用门店*/}
                      {(storesTypeChooseState ?? deStoresTypeChooseState) ===
                        '0' && (
                        <Box>
                          <Box mt={2.375} display="flex">
                            <Box className="checkbox-radio-disabled-color">
                              <Controller
                                render={(pr) => (
                                  <FormControlLabel
                                    variant="standard"
                                    checked={useStory ?? deUseStory}
                                    control={<Checkbox color="primary" />}
                                    label={
                                      <Box color="#000">
                                        {formatMessage({
                                          id: 'coupon.mgt.pricevalue.n01.txt73',
                                        })}
                                      </Box>
                                    }
                                    onChange={(e) => {
                                      setUseStory(e.target.checked);
                                      return pr.onChange(e.target.checked);
                                    }}
                                    disabled={queryType === 'detail'}
                                  />
                                )}
                                control={control}
                                name="useStory"
                              />
                            </Box>
                            {queryType !== 'detail' && (
                              <Button
                                disabled={
                                  (storesTypeChooseState ??
                                    deStoresTypeChooseState) === '1'
                                }
                                variant="contained"
                                className="stores-setting-button"
                                onClick={() => storesAddClick(1)}
                                title="Submit"
                              >
                                {formatMessage({
                                  id: 'coupon.mgt.pricevalue.n01.txt75',
                                })}
                              </Button>
                            )}
                            {queryType !== 'detail' && (
                              <Button
                                disabled={
                                  (storesTypeChooseState ??
                                    deStoresTypeChooseState) === '1'
                                }
                                variant="contained"
                                className="stores-setting-button"
                                onClick={() => storesImportClick(1)}
                                sx={{ marginLeft: '24px' }}
                              >
                                批量导入
                              </Button>
                            )}
                          </Box>

                          <Box width="710px" mt={3.5}>
                            <DataTableNativeML
                              pageButton={false}
                              columns={showColumns}
                              // data={storesChooseItemShowData}
                              data={initDataTables(
                                storesChooseItemShowData,
                                storePage,
                              )}
                              columnKey="id"
                              total={100}
                              devicesMinWidth="710"
                              np={true}
                            />
                          </Box>
                          {storesChooseItemShowData?.length > 0 && (
                            <Box
                              display="flex"
                              justifyContent="center"
                              gap="0 12px"
                              mt={1}
                            >
                              <Box
                                onClick={handleStorePrevious}
                                sx={{
                                  cursor: 'pointer',
                                  color:
                                    storePage === 1 ? '#C9C9C9' : 'inherit',
                                }}
                              >
                                {formatMessage({
                                  id: 'comm.pagination.lbl.03',
                                })}
                              </Box>
                              <Box>
                                {formatMessage({
                                  id: 'coupon.mgt.pricevalue.n01.txt99',
                                })}{' '}
                                {storePage}{' '}
                                {formatMessage({
                                  id: 'comm.pagination.lbl.05',
                                })}
                              </Box>
                              <Box
                                onClick={handleStoreDown}
                                sx={{
                                  cursor: 'pointer',
                                  color:
                                    storePage * 10 >=
                                    storesChooseItemShowData?.length
                                      ? '#C9C9C9'
                                      : 'inherit',
                                }}
                              >
                                {formatMessage({
                                  id: 'comm.pagination.lbl.04',
                                })}
                              </Box>
                              <Box>
                                {formatMessage({
                                  id: 'coupon.mgt.pricevalue.n01.txt76',
                                })}
                                {initPageSize(
                                  storesChooseItemShowData?.length || 0,
                                )}
                                {formatMessage({
                                  id: 'comm.pagination.lbl.05',
                                })}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      )}

                      {/*不可用门店*/}
                      {(storesTypeChooseState ?? deStoresTypeChooseState) ===
                        '0' && (
                        <Box>
                          <Box mt={3.5} display="flex">
                            <Box className="checkbox-radio-disabled-color">
                              <Controller
                                render={(pr) => (
                                  <FormControlLabel
                                    variant="standard"
                                    checked={noUseStory ?? deNoUseStory}
                                    control={<Checkbox color="primary" />}
                                    label={
                                      <Box color="#000">
                                        {formatMessage({
                                          id: 'coupon.mgt.pricevalue.n01.txt74',
                                        })}
                                      </Box>
                                    }
                                    onChange={(e) => {
                                      setNoUseStory(e.target.checked);
                                      return pr.onChange(e.target.checked);
                                    }}
                                    disabled={queryType === 'detail'}
                                  />
                                )}
                                control={control}
                                name="noUseStory"
                              />
                            </Box>
                            {queryType !== 'detail' && (
                              <Button
                                disabled={
                                  (storesTypeChooseState ??
                                    deStoresTypeChooseState) === '1'
                                }
                                variant="contained"
                                className="stores-setting-button"
                                onClick={() => storesAddClick(2)}
                                title="Submit"
                              >
                                {formatMessage({
                                  id: 'coupon.mgt.pricevalue.n01.txt75',
                                })}
                              </Button>
                            )}
                            {queryType !== 'detail' && (
                              <Button
                                disabled={
                                  (storesTypeChooseState ??
                                    deStoresTypeChooseState) === '1'
                                }
                                variant="contained"
                                className="stores-setting-button"
                                onClick={() => storesImportClick(2)}
                                sx={{ marginLeft: '24px' }}
                              >
                                批量导入
                              </Button>
                            )}
                          </Box>
                          <Box width="710px" mt={3.5}>
                            <DataTableNativeML
                              pageButton={false}
                              columns={showColumnsNo}
                              // data={storesChooseItemShowDataNo}
                              data={initDataTables(
                                storesChooseItemShowDataNo,
                                storePageNo,
                              )}
                              columnKey="id"
                              total={100}
                              devicesMinWidth="710"
                              np={true}
                            />
                          </Box>
                          {storesChooseItemShowDataNo?.length > 0 && (
                            <Box
                              display="flex"
                              justifyContent="center"
                              gap="0 12px"
                              mt={1}
                            >
                              <Box
                                onClick={handleStorePreviousNo}
                                sx={{
                                  cursor: 'pointer',
                                  color:
                                    storePageNo === 1 ? '#C9C9C9' : 'inherit',
                                }}
                              >
                                {formatMessage({
                                  id: 'comm.pagination.lbl.03',
                                })}
                              </Box>
                              <Box>
                                {formatMessage({
                                  id: 'coupon.mgt.pricevalue.n01.txt99',
                                })}{' '}
                                {storePageNo}{' '}
                                {formatMessage({
                                  id: 'comm.pagination.lbl.05',
                                })}
                              </Box>
                              <Box
                                onClick={handleStoreDownNo}
                                sx={{
                                  cursor: 'pointer',
                                  color:
                                    storePageNo * 10 >=
                                    storesChooseItemShowDataNo?.length
                                      ? '#C9C9C9'
                                      : 'inherit',
                                }}
                              >
                                {formatMessage({
                                  id: 'comm.pagination.lbl.04',
                                })}
                              </Box>
                              <Box>
                                {formatMessage({
                                  id: 'coupon.mgt.pricevalue.n01.txt76',
                                })}
                                {initPageSize(
                                  storesChooseItemShowDataNo?.length || 0,
                                )}
                                {formatMessage({
                                  id: 'comm.pagination.lbl.05',
                                })}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      )}

                      {/*不适用门店*/}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Button
              type="submit"
              ref={submitRefTwo}
              style={{ display: 'none' }}
            />
            <Box display="none">
              <Controller
                render={() => (
                  <TextField
                    variant="standard"
                    id="outlined-multiline-static"
                    autoComplete="off"
                    label=""
                  />
                )}
                control={control}
                name="stores"
              />
              <Controller
                render={() => (
                  <TextField
                    variant="standard"
                    id="outlined-multiline-static"
                    autoComplete="off"
                    label=""
                  />
                )}
                control={control}
                name="invertStores"
              />
            </Box>
          </form>
          {/* <DialogDataML
            open={dialogStatus}
            title={labelCom}
            content={storesContent()}
            onClose={onCloseDialog}
            button={{ isShow: false }}
          /> */}
          <StoreModal
            dialogStatus={dialogStatus}
            title="选择门店"
            chooseIds={storesChooseItemShowIdData}
            columns={columns}
            control={storeControl}
            getValues={getValuesStore}
            setValue={setValueStore}
            watch={watchStore}
            reset={resetStore}
            changePage={changePageStore}
            onCloseDialog={onCloseDialog}
            handleSubmit={handleSubmitStore}
            onSubmitSuccess={onSubmitSuccessStore}
            onHandleClickSearchStoresResetCallback={
              onHandleClickSearchStoresReset
            }
          />
          <StoreModal
            dialogStatus={dialogStatusNo}
            title="选择不可用门店"
            chooseIds={storesChooseItemShowIdDataNo}
            columns={columns}
            control={storeControlNo}
            getValues={getValuesStoreNo}
            setValue={setValueStoreNo}
            watch={watchStoreNo}
            reset={resetStoreNo}
            changePage={changePageStore}
            onCloseDialog={onCloseDialogNo}
            handleSubmit={handleSubmitStoreNo}
            onSubmitSuccess={onSubmitSuccessStoreNo}
            onHandleClickSearchStoresResetCallback={
              onHandleClickSearchStoresResetNo
            }
          />
          <DialogDataML
            open={batchImportOpen}
            title={
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <span style={{ fontSize: '18px', fontWeight: 600 }}>
                  批量上传
                </span>
                <IconButton
                  aria-label="close"
                  onClick={() => onCloseBatchImportDialog()}
                >
                  <CloseIcon className="coupon-dialog-close-icon-style" />
                </IconButton>
              </Box>
            }
            content={batchImportContent()}
            onClose={onCloseBatchImportDialog}
            button={initButton()}
          />
        </Box>
      );
    },
);
